<template>
  <!-- 待我审批的、我已审批的、我发起的、待我审批的 页面公用 -->
  <div class="aprove-done">
    <div class="wrap g-shadow">
      <div class="header">
        <div class="header" v-if="this.pageType === 'done' || this.pageType === 'mystart' || this.pageType === 'copy'">
          <el-tabs class="cus-tabs-border" v-model="activeTab" @tab-click="handleClick">
            <el-tab-pane v-for="item in tabList" :key="item.value" :label="item.name" :name="item.value"></el-tab-pane>
            <!-- <el-tab-pane label="全部" name="1"></el-tab-pane>
            <el-tab-pane label="审批通过" name="2"></el-tab-pane>
            <el-tab-pane label="审批拒绝" name="3"></el-tab-pane>
            <el-tab-pane label="审批中" name="4"></el-tab-pane>
            <el-tab-pane label="已撤销" name="5"></el-tab-pane>-->
          </el-tabs>
        </div>

        <!-- <el-form :class="{'formStyle': this.pageType === 'done' || this.pageType === 'mystart' || this.pageType === 'copy'}" ref="form" :model="form" label-width="80px">
          <el-form-item label="标题 :" prop="title">
            <el-input v-model="form.title" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="申请类型 :" prop="approvalType" placeholder="请输入">
            <el-select v-model="form.approvalType" placeholder="请选择">
              <el-option v-for="item in approvalType" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="com-head-search-btns ml-30">
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div> -->
      </div>

      <!-- 列表头部 -->
      <div class="com-list-header" style="padding-left: 0;width: 70%;">
        <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="10" v-if="pageType=='copy'">
              <el-form-item label="标题 :" prop="title">
                <el-input v-model="form.title" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="申请类型 :" prop="approvalType">
                <el-select v-model="form.approvalType" placeholder="请选择">
                  <el-option
                    v-for="item in approvalType"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="com-head-search-btns">
          <el-button type="primary" @click="getTableList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div>
      </div>

      <div class="button" v-if="pageType=='copy'">
        <el-button @click="exportList" :class="{'el-primary-border':chooseRowIds}" :disabled="!chooseRowIds">
          <i class="el-icon-download"></i>&nbsp;批量打印
        </el-button>
      </div>

      <!-- 表格 -->
      <el-table v-loading="listLoading" class="cus-table-bg-no" :data="tableData" :row-key="(row)=>{ return row.schemeId }" style="width: 100%" @row-click="rowClick" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- <el-table-column type="index" :index="getIndex" label="序号" width="120"></el-table-column> -->
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ scope.$index+1 }}</template>
        </el-table-column>
        <el-table-column prop="title" label="审批标题" min-width="100%">
          <template slot-scope="scope">
            <span class="m-dot-box m-danger">
              <i class="m-circle-dot" v-if="scope.row.read==='未读'"></i>
            </span>
            {{ scope.row.title }}
            <span class="m-danger" v-if="scope.row.isCancel">【申请撤销】</span>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="发起时间"></el-table-column>
        <el-table-column prop="endTime" label="完成时间" v-if="pageType!=='pending'"></el-table-column>
        <el-table-column label="是否已读" v-if="pageType==='copy'">
          <template slot-scope="scope">
            <span :class="{'m-tint': scope.row.read==='已读'}">{{ scope.row.read }}</span>
          </template>
        </el-table-column>
        <el-table-column label="当前状态" width="150">
          <template slot-scope="scope">
            <!-- 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->
            <!-- 'm-primary': scope.row.statusCode==='2', -->
            <span :class="{
                'm-warning ': scope.row.statusCode==='1',
                'm-tint': scope.row.statusCode==='4',
                'm-info': scope.row.statusCode==='6',
                'm-danger': scope.row.statusCode==='3'}">{{ scope.row.status }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>

    <approve-panel ref="approvePanel" :roleType="pageType" @refresh="initList"></approve-panel>
  </div>
</template>

<script>
// import bus from '@/utils/bus'
import approvePanel from './dialog/approve-panel' // 审批面板
export default {
  components: {
    approvePanel
  },
  watch: {
    $route(path) {
      this.activeTab = '0'
      this.form.approvalType = ''
      this.pageType = path.query.state
      // this.$refs.approvePanel.closePanel()

      if (this.$route.query.actvityId) {
        // 从通知跳转过来
        this.$nextTick(() => {
          this.$refs.approvePanel.init({
            actvityId: this.$route.query.actvityId
          })
        })
      } else {
        this.$refs.approvePanel.closePanel()
      }
    }
  },
  data() {
    return {
      // 页面类型 pending:待我审批的 done:我已审批的 mystart:我发起的 copy:抄送我的
      pageType: this.$route.query.state,
      activeTab: null,
      tabList: [],
      tableData: [],
      listLoading: true,
      form: {
        approvalType: '',
        title: ''
      },
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      approvalType: [], // 审批类型
      chooseRowIds: ''
    }
  },
  created() {
    this.initList()

    // 从通知跳转过来
    if (this.$route.query.actvityId) {
      this.$nextTick(() => {
        this.$refs.approvePanel.init({ actvityId: this.$route.query.actvityId })
      })
    }
  },
  mounted() {
    // bus.$on('globalApproveEvent', () => {
    //   this.getDataList()
    // })
  },
  methods: {
    // 初始化表格
    initList() {
      let action = ''
      switch (this.pageType) {
        case 'pending':
          action = '1'
          this.$store.dispatch('updataSiderbarCount')
          break
        case 'done':
          action = '2'
          break
        case 'mystart':
          action = '0'
          break
        case 'copy':
          action = '9'
          break
      }
      this.listLoading = true
      this.$http
        .post('/workflowActvity/list', {
          ...this.listQuery,
          action: action,
          type: this.form.approvalType,
          status: this.activeTab === '0' ? '' : this.activeTab,
          title: this.form.title
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result.data
            this.total = res.page.allRow

            let firstArr = [{ value: null, name: '全部' }]
            this.approvalType = firstArr.concat(res.result.type)
            this.tabList = firstArr.concat(res.result.status)
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 表格点击当前行
    rowClick(row) {
      this.pageType = this.$route.query.state
      this.$refs.approvePanel.init(row)
    },

    // tabs获取点击事件参数
    handleClick() {
      this.getTableList()
      this.listQuery.name = this.activeTab
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 重置查询
    restList() {
      this.activeTab = '0'

      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 获取表格索引
    getIndex(index) {
      return (this.listQuery.currentPage - 1) * this.listQuery.size + index + 1
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.actvityId)
      })
      this.chooseRowIds = arr.join(',')
    },

    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要打印的数据')
        return
      }
      location.href = '/singleMuseum/workflowInst/printBatch?arr=' + this.chooseRowIds
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  }
}
</script>

<style lang="scss" scoped>
.aprove-done {
  .wrap {
    padding: 30px 20px 30px 30px;
    background: #fff;
    .header {
      display: flex;
      /deep/.el-input {
        width: 300px !important;
      }
    }

    .el-table {
      .m-dot-box.m-danger {
        position: absolute;
        left: 0;
      }
      /deep/ tr {
        cursor: pointer;
      }
      /deep/th.is-leaf {
        border-bottom: 1px solid #eeeff5;
      }
      /deep/td {
        border-bottom: 1px solid #eeeff5;
      }
    }
  }
}
.formStyle {
  margin-left: 76px;
}
</style>


